import Nullstack from 'nullstack';
export default function IconSchemaOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-schema-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 2h4v4m-4 0h-1v-1"
  }), "   ", Nullstack.element("path", {
    d: "M15 11v-1h5v4h-2"
  }), "   ", Nullstack.element("path", {
    d: "M5 18h5v4h-5z"
  }), "   ", Nullstack.element("path", {
    d: "M5 10h5v4h-5z"
  }), "   ", Nullstack.element("path", {
    d: "M10 12h2"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 7.5v2.5"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 14v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}